<template>
    <div class="progress">
        <zoe-molecules-bar-progress
            v-if="props.content.type.value === 'bar' || (store.state.quiz.advancedFlow && !store.state.quiz.equalFlow)"
            :content="props.content.bar"
            v-bind="moleculeProps"
        />

        <zoe-molecules-orbs-progress
            v-else-if="props.content.type.value === 'orbs'"
            :content="props.content.orbs"
            v-bind="moleculeProps"
        />

        <zoe-molecule-small-orbs-progress
            v-else-if="props.content.type.value === 'smallOrbs'"
            :content="props.content['smallOrbs']"
            v-bind="moleculeProps"
        />

        <zoe-molecule-iconography-progress
            v-else-if="props.content.type.value === 'iconography'"
            :content="props.content.iconography"
            v-bind="moleculeProps"
        />

        <zoe-molecule-journey-progress
            v-else-if="props.content.type.value === 'journey'"
            :content="props.content.journey"
            v-bind="moleculeProps"
        />
    </div>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { componentProps } from '../../../../mixins/component/component';
import { get } from '../../../../../../resources/frontend/js/mixins/get-page-data.js';
import ZoeMoleculesBarProgress from '@molecules/progress/progress-bar/v1.0.0/zoe-molecule-progress-bar.vue';
import ZoeMoleculesOrbsProgress from '@molecules/progress/progress-orbs/v1.0.0/zoe-molecule-progress-orbs.vue';
import ZoeMoleculeSmallOrbsProgress from '@molecules/progress/progress-small-orbs/v1.0.0/zoe-molecule-progress-small-orbs.vue';
import ZoeMoleculeIconographyProgress from '@molecules/progress/progress-iconography/v1.0.0/zoe-molecule-progress-iconography.vue';
import ZoeMoleculeJourneyProgress from '@molecules/progress/progress-journey/v1.0.0/zoe-molecule-progress-journey.vue';

const store = useStore();

const props = defineProps({
    ...componentProps,
    questionOverwrite: {
        type: Number,
        default: null,
    },
    totalQuestionsOverwrite: {
        type: Number,
        default: null,
    },
});

onMounted(() => {
    if (props.questionOverwrite) store.state.quiz.questionCount = props.questionOverwrite;
});

watch(() => props.questionOverwrite, () => {
    if (props.questionOverwrite) store.state.quiz.questionCount = props.questionOverwrite;
});

const moleculeProps = computed(() => {
    const isAdvancedFlow = store.state.quiz.advancedFlow;
    const isContinuousFlow = store.state.quiz.continuousFlow;
    const quizTotalFlowLength = store.state.quiz.totalFlowLength;
    const obj = {};

    if (isContinuousFlow) {
        const continuousStep = get('quiz.form') || get('step.form');
        const formSteps = Object.keys(continuousStep.steps).length;

        if (isAdvancedFlow) quizTotalFlowLength - 1;
        obj.continuousFlowLength = quizTotalFlowLength + formSteps;
    }

    if (props.totalQuestionsOverwrite !== null) {
        obj.totalQuestionsOverwrite = props.totalQuestionsOverwrite;
    }

    return obj;
});
</script>

<style lang="scss" scoped>
@use 'zoe-organism-progress';
</style>
